import BaseModule from './BaseModule.js';

class Customer extends BaseModule {
  async create(customer) {
    return await this.post(`/back-office/customers`, customer);
  }

  async paginate({ page, per_page, term, status }) {
    return await this.get(`back-office/customers`, {
      params: { page, per_page, term, status },
    });
  }

  async fetch(id) {
    return await this.get(`/back-office/customers/${id}`);
  }

  async update(customer) {
    return await this.patch(`/back-office/customers/${customer.id}`, customer);
  }

  async createProviderCredential(data) {
    return await this.post(`/back-office/customers/providers`, data);
  }

  async updateProviderCredential(data) {
    return await this.patch(`/back-office/customers/providers/${data.id}`, data);
  }

  async removeProviderCredential(id) {
    return await this.delete(`/back-office/customers/providers/${id}`);
  }

  async createApiCredential(credential) {
    return await this.post(`/back-office/customers/${credential.id}/api_credentials`, credential);
  }

  async removeCredential(customer_id, api_credential_id) {
    return await this.delete(
      `/back-office/customers/${customer_id}/api_credentials/${api_credential_id}/`,
    );
  }

  async createCustomerPlan(plan) {
    return await this.post(`/back-office/customers/${plan.customer_id}/plans`, plan);
  }

  async updateCustomerPlan(data) {
    return await this.patch(`/back-office/customers/plans/${data.id}`, data);
  }

  async removeCustomerPlan(customer_id, customer_plan_id) {
    return await this.delete(`/back-office/customers/${customer_id}/plans/${customer_plan_id}/`);
  }

  async resetMfa(customerId, data = {}) {
    return await this.post(`/back-office/customers/${customerId}/mfa/reset`, data);
  }

  async resetPassword(customerId, data = {}) {
    return await this.post(`/back-office/customers/${customerId}/password/reset`, data);
  }

  async lookupByCnpj(cnpj) {
    return await this.get(`/back-office/customer/cnpj`, {
      params: { cnpj },
    });
  }

  async fetchAddress(cep) {
    return await this.get(`/back-office/address/zipcode/${cep}`);
  }
}

export default Customer;
